import * as React from "react";
import { DEFAULT_VALUES_PINNED_ROW } from "../detail-list/helpers";
import { NoteComponent } from "./note-component";

interface IProps {
    data: any;
}

export const noteDecorator = (Component) => {
    return class NoteDecorator extends React.PureComponent<IProps, any> {
        declare noteComponent: NoteComponent;

        render() {
            if (this.props.data?.type !== DEFAULT_VALUES_PINNED_ROW) {
                this.noteComponent = new NoteComponent();
                this.noteComponent.init(this.props);
            }

            return <Component {...this.props} />;
        }

        destroy() {
            if (this.noteComponent) {
                this.noteComponent.destroy();
                delete this.noteComponent;
            }
        }

        refresh() {
            return false;
        }
    };
};
